// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-pdf"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4V22H20M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 16V13H9.71428C9.87208 13 10 13.1279 10 13.2857V15.7143C10 15.8721 9.87208 16 9.71428 16H7ZM7 16V19M20.6667 13H18.2857C18.1279 13 18 13.1279 18 13.2857V16M18 16H20.6667M18 16V19M12.5 13V19H15.2143C15.3721 19 15.5 18.8721 15.5 18.7143V13.2857C15.5 13.1279 15.3721 13 15.2143 13H12.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FilePdfIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-pdf',
    ref,
    icon: element,
  },
));

FilePdfIcon.displayName = 'FilePdfIcon';

export default FilePdfIcon;
